import { OrganizationProjectOverview } from "@/src/features/organizations/components/OrganizationProjectOverview";

export default function Home() {
  return <OrganizationProjectOverview />;
}
